/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface SessionReferencesCountsDto
 */
export interface SessionReferencesCountsDto {

    /**
     * Distinct assignments
     *
     * @type {number}
     * @memberof SessionReferencesCountsDto
     */
    assignments: number;

    /**
     * Session events
     *
     * @type {number}
     * @memberof SessionReferencesCountsDto
     */
    events: number;

    /**
     * Distinct members
     *
     * @type {number}
     * @memberof SessionReferencesCountsDto
     */
    members: number;
}
